import AgreementsApiService from './AgreementsApiService'
import AvailabilityApiService from './AvailabilityApiService'
import BookingsApiService from './BookingsApiService'
import CertificationsApiService from './CertificationsApiService'
import DoceboApiService from './DoceboApiService'
import DocumentsApiService from './DocumentsApiService'
import DownloadsApiService from './DownloadsApiService'
import EventsApiService from './EventsApiService'
import FileApiService from './FileApiService'
import FormsApiService from './FormsApiService'
import ProfessionalDevelopmentApiService from './ProfessionalDevelopmentApiService'
import QualificationsApiService from './QualificationsApiService'
import Ready2WorkApiService from './Ready2WorkApiService'
import RegistrationApiService from './RegistrationsApiService'
import SignalRApiService from './SignalRApiService'
import SubjectsApiService from './SubjectsApiService'
import TimeEntriesApiService from './TimeEntriesApiService'
import UserApiService from './UserApiService'
import WorkExperienceApiService from './WorkExperienceApiService'

export default {
  agreements: new AgreementsApiService(),
  availability: new AvailabilityApiService(),
  bookings: new BookingsApiService(),
  certifications: new CertificationsApiService(),
  documents: new DocumentsApiService(),
  docebo: new DoceboApiService(),
  downloads: new DownloadsApiService(),
  events: new EventsApiService(),
  file: new FileApiService(),
  forms: new FormsApiService(),
  professionalDevelopment: new ProfessionalDevelopmentApiService(),
  qualifications: new QualificationsApiService(),
  ready2Work: new Ready2WorkApiService(),
  registrations: new RegistrationApiService(),
  signalR: new SignalRApiService(),
  subjects: new SubjectsApiService(),
  timeEntries: new TimeEntriesApiService(),
  user: new UserApiService(),
  workExperience: new WorkExperienceApiService(),
}
